import makeBranchItem from './makeBranchItem';
import checkIfCompanyDataIsNull from './checkIfCompanyDataIsNull';
import { BRANCH_NOT_FOUND } from '../constants';

const getInitialValues = (initialData, isEndUser, branches, companyData, branch) => {
  if (isEndUser) {
    return {
      salutation: initialData.salutation,
      firstName: initialData.firstName,
      lastName: initialData.lastName,
      language: initialData.language,
    };
  } else {
    const company = {
      name: companyData.label,
      uid: companyData.uid,
      uri: companyData.uri,
    };

    if (branches?.length > 0) {
      let mainAddress;
      if (branch?.name === BRANCH_NOT_FOUND) {
        mainAddress = {
          value: BRANCH_NOT_FOUND,
        };
      } else if (!branch) {
        mainAddress = branches[0];
      } else {
        mainAddress = {
          value: {
            hq: true,
            street: branch.street,
            city: branch.city,
            zip: branch.zip,
            label: `${branch.street}, ${branch.zip} ${branch.city}`,
          },
          label: `${branch.street}, ${branch.zip} ${branch.city}`,
        };
      }
      company.branch = makeBranchItem(mainAddress?.value);
    }

    return {
      salutation: initialData.salutation,
      firstName: initialData.firstName,
      lastName: initialData.lastName,
      companyData: checkIfCompanyDataIsNull(companyData),
      userFunction: initialData.function,
      language: initialData.language,
      company: company,
    };
  }
};

export default getInitialValues;
